
import { ImageGenerationOptions } from '../types';

/**
 * Validates image generation options on the frontend
 * Now supports both direct prompts and prompt building parameters
 */
export const validateGenerationOptions = (options: ImageGenerationOptions): string | null => {
  // Check if we have either a positive prompt OR valid prompt building parameters
  const hasPositivePrompt = options.positivePrompt && options.positivePrompt.trim() !== "";
  const hasPromptBuildingParams = options.basePromptId || 
                                 options.styleId || 
                                 options.influenceId || 
                                 options.backgroundId ||
                                 (options.environmentIds && options.environmentIds.length > 0) ||
                                 (options.moodIds && options.moodIds.length > 0) ||
                                 options.additionalText;

  if (!hasPositivePrompt && !hasPromptBuildingParams) {
    return "Either a positive prompt or prompt building parameters are required";
  }
  
  // Validate dimensions if provided
  if (options.width && (options.width < 64 || options.width > 2048)) {
    return "Width must be between 64 and 2048 pixels";
  }
  
  if (options.height && (options.height < 64 || options.height > 2048)) {
    return "Height must be between 64 and 2048 pixels";
  }
  
  // Validate number of results
  if (options.numberResults && (options.numberResults < 1 || options.numberResults > 10)) {
    return "Number of results must be between 1 and 10";
  }
  
  return null; // Valid
};
